// jQuery('#latestCaseStudiesSlider').slick({
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     // autoplay: true,
//     // autoplaySpeed: 5000,
//     infinite: false,
//     arrows: true,
//     prevArrow: jQuery(".latest-case-studies-prev"),
//     nextArrow: jQuery(".latest-case-studies-next"),
//     // centerMode: true,
//     // centerPadding: '100px',
// });
jQuery('#latestCaseStudiesSlider').slick({
    slidesToShow: 1.3,
    slidesToScroll: 1,
    // autoplay: true,
    // autoplaySpeed: 5000,
    infinite: false,
    arrows: true,
    prevArrow: jQuery(".latest-case-studies-prev"),
    nextArrow: jQuery(".latest-case-studies-next"),
    // centerMode: true,
    // centerPadding: '100px',
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
            }
        },
        {
            breakpoint: 640,
            settings: {
                slidesToShow: 1,
                centerMode: true,
                centerPadding: '15px'
            }
        }
    ]
});

jQuery('#latestCaseStudiesSlider .background-container').on('click', function(e) {
    e.preventDefault();

    var id = jQuery(this).closest('.slick-slide').attr('data-slick-index');
    var link = jQuery(this).attr('href');

    // Hide the other slides
    jQuery('#latestCaseStudiesSlider .slick-slide:not([data-slick-index="'+id+'"])').hide();
    jQuery('#latestCaseStudiesSlider .slick-track').css('transform', 'translate3d(0px, 0px, 0px)');

    // scroll to top of slider
    var offset = jQuery('#latestCaseStudiesSlider').offset();
    jQuery('html, body').animate({
        scrollTop: offset.top - 120
    }, 5);

    jQuery('#latestCaseStudiesSlider .background-container').removeClass('has-hover');

    if (jQuery(window).width() > 900) {
        // zoom in
        setTimeout(function() {
            if (jQuery(window).width() > 1600) {
                jQuery('#latestCaseStudiesSlider .case-study-slide').animate({paddingLeft: '9%'}, 300);
            }
            if (jQuery(window).width() > 1500) {
                jQuery('#latestCaseStudiesSlider .slick-slide[data-slick-index="'+id+'"] .background-container img').transition({ scale: 1.2, width: '1175px', x: '100px' }, 400);
                // jQuery('#latestCaseStudiesSlider .slick-slide[data-slick-index="'+id+'"] .background-container img').transition({ scale: 1.2, width: '1250px', x: '100px' }, 400);
            } else {
                // jQuery('#latestCaseStudiesSlider .slick-slide[data-slick-index="'+id+'"] .background-container img').transition({ scale: 1.2 }, 400);
                jQuery('#latestCaseStudiesSlider .slick-slide[data-slick-index="'+id+'"] .background-container img').transition({ scale: 1.238 }, 400);
            }

        }, 200);

        // fade out the arrows
        setTimeout(function() {
            jQuery('.latest-case-studies .arrows').fadeOut();
        }, 100);

        jQuery('.latest-case-studies').animate({backgroundColor: '#0B0B15'}, 500);
        jQuery('.latest-case-studies').css('background', 'unset');

        // fade out the foreground e.g. the sofa, plant, desk etc.
        jQuery('#latestCaseStudiesSlider .slick-slide[data-slick-index="'+id+'"] .foreground-container').fadeOut(1500);

        // fade out the content e.g. the title
        jQuery('#latestCaseStudiesSlider .slick-slide[data-slick-index="'+id+'"] .content').fadeOut();
    }

    // go to case study page
    setTimeout(function() {
        window.location.href = link;
    }, 1000);

    setTimeout(function() {
        jQuery('#latestCaseStudiesSlider .slick-slide[data-slick-index="'+id+'"] .background-container img').fadeOut(600);
    }, 950)
});

jQuery('#latestCaseStudiesSlider .background-container .button').on('click', function(e) {
    e.preventDefault();

    var id = jQuery(this).closest('.slick-slide').attr('data-slick-index');
    var link = jQuery(this).attr('href');

    // Hide the other slides
    jQuery('#latestCaseStudiesSlider .slick-slide:not([data-slick-index="'+id+'"])').hide();
    jQuery('#latestCaseStudiesSlider .slick-track').css('transform', 'translate3d(0px, 0px, 0px)');

    // scroll to top of slider
    var offset = jQuery('#latestCaseStudiesSlider').offset();
    jQuery('html, body').animate({
        scrollTop: offset.top - 120
    }, 5);

    jQuery('#latestCaseStudiesSlider .background-container').removeClass('has-hover');

    if (jQuery(window).width() > 900) {
        // zoom in
        setTimeout(function() {
            if (jQuery(window).width() > 1600) {
                jQuery('#latestCaseStudiesSlider .case-study-slide').animate({paddingLeft: '9%'}, 300);
            }
            if (jQuery(window).width() > 1500) {
                jQuery('#latestCaseStudiesSlider .slick-slide[data-slick-index="'+id+'"] .background-container img').transition({ scale: 1.2, width: '1175px', x: '100px' }, 400);
                // jQuery('#latestCaseStudiesSlider .slick-slide[data-slick-index="'+id+'"] .background-container img').transition({ scale: 1.2, width: '1250px', x: '100px' }, 400);
            } else {
                // jQuery('#latestCaseStudiesSlider .slick-slide[data-slick-index="'+id+'"] .background-container img').transition({ scale: 1.2 }, 400);
                jQuery('#latestCaseStudiesSlider .slick-slide[data-slick-index="'+id+'"] .background-container img').transition({ scale: 1.238 }, 400);
            }
        }, 200);

        // fade out the arrows
        setTimeout(function() {
            jQuery('.latest-case-studies .arrows').fadeOut();
        }, 100);

        jQuery('.latest-case-studies').animate({backgroundColor: '#0B0B15'}, 500);
        jQuery('.latest-case-studies').css('background', 'unset');

        // fade out the foreground e.g. the sofa, plant, desk etc.
        jQuery('#latestCaseStudiesSlider .slick-slide[data-slick-index="'+id+'"] .foreground-container').fadeOut(1500);

        // fade out the content e.g. the title
        jQuery('#latestCaseStudiesSlider .slick-slide[data-slick-index="'+id+'"] .content').fadeOut();
    }

    // go to case study page
    setTimeout(function() {
        window.location.href = link;
    }, 1000);

    setTimeout(function() {
        jQuery('#latestCaseStudiesSlider .slick-slide[data-slick-index="'+id+'"] .background-container img').fadeOut(600);
    }, 950)
});



// jQuery('#latestCaseStudiesSlider').slick({
//     slidesToShow: 1.2,
//     slidesToScroll: 1,
//     // autoplay: true,
//     // autoplaySpeed: 5000,
//     infinite: false,
//     arrows: true,
//     prevArrow: jQuery(".latest-case-studies-prev"),
//     nextArrow: jQuery(".latest-case-studies-next"),
// });